import gql from 'graphql-tag'

export const fetchProductsAggregationsQuery = gql`
  query ($sku: [String] $runner_type: [String]) {
    products(filter: {sku: {in: $sku}, runner_type: {in: $runner_type}}) {
      aggregations {
        attribute_code
        count
        label
        options {
          label
          value
          count
          __typename
        }
        __typename
      }
      __typename
    }
  }
`
